export default __webpack_public_path__ + "static/media/Email.ab973490.svg";